export const baseUrl = (state) => {
    return state.baseUrl
}
export const getMode = (state) => {
    return state.mode
}
export const getUserInfo = (state) => {
    return state.userInfo
}
export const getSubuserInfo = (state) => {
    return state.subuserInfo
}
export const getItemsInfoCart = (state) => {
    return state.getCartDetails
}
export const getCustomerNo = (state) => {
    return state.getCustomerNumber
}
export const getPageName = (state) => {
    return state.pageNameProduct
}
export const getAutoRenewItem = (state) => {
    return state.AutoRenewItem;
}
export const getSubscriberDetails = (state) => {
    return state.SubscriberDetails;
}
export const getItemsCheckoutCart = (state) => {
    return state.getCheckoutDetails
}
export const getSideNavInfo = (state) => {
    return state.getSideNavInfoDetails
}
export const getReportQueueing = (state) => {
    return state.ReportQueueing;
}
export const getInvoiceCartDetails = (state) => {
    return state.invoiceCartDetails;
}
export const getsideNav = (state) => {
    return state.sideNav;
}
export const getCustomerEnterId = (state) => {
    return state.customerEnteredId;
}
export const getPlanListingData = (state) => {
    return state.planListingData;
}
export const firebaseUrl = (state) => {
    return state.firebaseUrl
}
export const getUniqueCustomerId = (state) => {
    return state.uniqueCustomerId;
}
export const getShowAllModule = (state) => {
    return state.showAllModule;
}
export const portalCode = (state) => {
    return state.portalCode
}
export const getOTTVerifiedUsers  = (state) => {
    return state.ottVerifiedUsers
}
export const getChangeBasePackDetails = (state) => {
    return state.changeBasePack
}
export const getChangeValidityPackDetails = (state) => {
    return state.changeValidity
}
export const getSMSTemplates  = (state) => {
    return state.SMSTemplates
}
export const getVerifiedBroadbandCustomer = (state) => {
    return state.verifiedBroadbandCustomer
}


// WEBPACK FOOTER //
// ./src/store/getters.js